export const colors = {
  bgColor: '#f5f5f5',
  darkBlue: '#2e3d5c',
  gray: '#959dad',
  lightBlue: '#f1f3f6',
  lightGray: '#b6bbc4',
  white: '#ffffff',
  red: '#e55457',
  orange: '#FF8800',
  yellow: '#ffb500',
  green: '#77a846',
  saunaBackground: '#E6E7E8',
  saunaDarkBlue: '#384F63',
  saunaLightBlue: '#B0CCD9',
  saunaBeige: '#B39D90',
};
